var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":"ny_vejkode","maxlength":"4","pattern":"\\d*","placeholder":"(Ingen)"},domProps:{"value":this.vejkode},on:{"keyup":_vm.validateInput}})}
var staticRenderFns = []

export { render, staticRenderFns }